import React from "react";
var __jsx = React.createElement;
import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import LexicalErrorBoundary from "@lexical/react/LexicalErrorBoundary";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";
import { ListPlugin } from "@lexical/react/LexicalListPlugin";
import { LinkPlugin } from "@lexical/react/LexicalLinkPlugin";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { ListItemNode, ListNode } from "@lexical/list";
import { AutoLinkNode, LinkNode } from "@lexical/link";
import { CodeNode } from "@lexical/code";
import { EDITOR_THEME } from "./editor-theme";
import { ImageNode } from "./image-node";
import { VariableNode } from "./variable-node";
import { LayoutContainerNode } from "./layout-container-node";
import { LayoutItemNode } from "./layout-item-node";
import { ImagesPlugin } from "./images-plugin";
import { LayoutPlugin } from "./layout-plugin";
import { VariableValuesPlugin } from "./variable-values-plugin";
import { HtmlOnChangePlugin, InitialHtmlPlugin, ReadOnlyPlugin } from "./editor-plugins";
import { LetterToolbar } from "./letter-toolbar";
import { VariableTypeaheadPlugin } from "./variable-typeahead-plugin";
/** Reusable Lexical editor for letters (compose, read-only view, and templates). */
export function LetterEditor(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
    onImageFile = _ref.onImageFile,
    variableValues = _ref.variableValues,
    variables = _ref.variables,
    _ref$enableLink = _ref.enableLink,
    enableLink = _ref$enableLink === void 0 ? false : _ref$enableLink;
  var initialConfig = {
    namespace: "letter-editor",
    theme: EDITOR_THEME,
    editable: !readOnly,
    onError: function onError(error) {
      throw error;
    },
    nodes: [HeadingNode, QuoteNode, ListNode, ListItemNode, LinkNode, AutoLinkNode, CodeNode, ImageNode, VariableNode, LayoutContainerNode, LayoutItemNode]
  };
  return /*#__PURE__*/React.createElement(LexicalComposer, {
    initialConfig: initialConfig
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex min-h-0 flex-1 flex-col gap-2"
  }, readOnly ? null : /*#__PURE__*/React.createElement(LetterToolbar, {
    onImageFile: onImageFile,
    enableLink: enableLink
  }), /*#__PURE__*/React.createElement("div", {
    className: "relative min-h-0 flex-1 overflow-y-auto"
  }, /*#__PURE__*/React.createElement(RichTextPlugin, {
    contentEditable: /*#__PURE__*/React.createElement(ContentEditable, {
      className: "min-h-64 w-full text-style-body-base text-sds-base-default focus:outline-none"
    }),
    placeholder: /*#__PURE__*/React.createElement("div", {
      className: "pointer-events-none absolute left-0 top-0 text-style-body-base text-sds-base-tertiary"
    }, placeholder),
    ErrorBoundary: LexicalErrorBoundary
  }))), /*#__PURE__*/React.createElement(HistoryPlugin, null), /*#__PURE__*/React.createElement(ListPlugin, null), /*#__PURE__*/React.createElement(LinkPlugin, null), /*#__PURE__*/React.createElement(ImagesPlugin, null), /*#__PURE__*/React.createElement(LayoutPlugin, null), /*#__PURE__*/React.createElement(InitialHtmlPlugin, {
    html: value
  }), /*#__PURE__*/React.createElement(HtmlOnChangePlugin, {
    onChange: onChange
  }), /*#__PURE__*/React.createElement(VariableValuesPlugin, {
    values: variableValues !== null && variableValues !== void 0 ? variableValues : {}
  }), !readOnly && variables && variables.length > 0 ? /*#__PURE__*/React.createElement(VariableTypeaheadPlugin, {
    variables: variables
  }) : null, /*#__PURE__*/React.createElement(ReadOnlyPlugin, {
    readOnly: readOnly
  }));
}